import Scene from "~/scene";
import SceneGeometryMulti from "~/scene/geometry/multi";
import { store } from "~/state/store";
import { MAP_OVERLAYS } from "./state/map/constants";
import { watch, watchCoordinates } from "~/state/util";
import { addListener, removeListener } from "~/lib/signals";

const layer = Scene.createLayerGeometry("cadastral-active-geometry");
let openedWindowReference = null;
let checkOpenedInterval = null;
let listener = "";
const actualGeometry = Scene.createGeometry(Scene.GEOMETRY.PATH, null, null, {
	color: "#ff0000",
	opacity: 0.2,
	width: 1,
	outlineOpacity: 1,
	outlineWidth: 3,
	outlineColor: "#ff0000",
});

layer.addGeometry(actualGeometry);

export function openCadastralEntity(source: string, id: number, geometry: SceneGeometryMulti) {
	const geometryData = geometry.getCreateData();
	const link = geometryData?.data?.extend?.link[0]?.url;
	let storeUnsubscribe = null;

	Mapy.getComponent("logger").log("click", {
		text: "cadastralArea",
	});

	if (geometry.getGeometries()[0]?.getType() === Scene.GEOMETRY.PATH) {
		const path = geometry.getPath();

		if (path?.length) {
			actualGeometry.setCoords([path]);
			Scene.addLayer(layer).enable();

			const wt = watch(store.getState, "map", watchCoordinates);

			storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
				if (
					newMap.longitude !== oldMap.longitude
					|| newMap.latitude !== oldMap.latitude
					|| newMap.zoom !== oldMap.zoom
				) {
					actualGeometry.setCoords([geometry.getPath()]);
				}
			}));

			listener = addListener({}, "width-change", () => {
				geometry && actualGeometry.setCoords([geometry.getPath()]);
			});
		}
	}

	if (link) {
		openedWindowReference && openedWindowReference.close();

		openedWindowReference = window.open(link, "MapyCOMCadastralLink", "left=0,top=0,width=600,height=660,popup=1");

		if (geometry.getGeometries()[0]?.getType() === Scene.GEOMETRY.PATH) {
			checkOpenedInterval = setInterval(() => {
				const { mapset, currentOverlays } = store.getState().map;
				const hide = mapset in currentOverlays && currentOverlays[mapset].indexOf(MAP_OVERLAYS.CADASTRAL) === -1;

				if (openedWindowReference.closed || hide) {
					clearInterval(checkOpenedInterval);
					storeUnsubscribe?.();
					removeListener(listener);
					listener = "";
					layer.disable();
					Scene.removeLayer(layer);
				}
			}, 500);
		}
	}
}
